import { Component } from '@angular/core';
import { ExportConsumptionTrackingFormComponent } from '../components/export-consumption-tracking-form/export-consumption-tracking-form.component';

@Component({
  selector: 'admin-consumption-tracking-container',
  standalone: true,
  imports: [ExportConsumptionTrackingFormComponent],
  templateUrl: './consumption-tracking.container.html',
  styleUrls: ['./consumption-tracking.container.scss'],
})
export class ConsumptionTrackingContainer {}
